module.exports = __webpack_public_path__ + "img/36-Frequent hair loss.8dacf33d.png";